export const EVENT_TABS_IDS = {
  LIST_PARTICIPANTS: 0,
  ORGANIZERS: 1,
};

export const EVENT_TABS = [
  { id: EVENT_TABS_IDS.LIST_PARTICIPANTS, title: 'Список участников' },
  { id: EVENT_TABS_IDS.ORGANIZERS, title: 'Организаторы' },
];
